import { FavoriteDoorService } from './favorite-door.service';
import { Injectable } from '@angular/core';
import { lastValueFrom, Observable, ReplaySubject, take } from 'rxjs';
import { CountFavoritesGQL, ToggleVisualDoorFavoriteGQL } from '../../../generated/graphql';
import { CustomerService } from '../customer/customer.service';
import {CustomerServiceImpl} from "../customer/customer.service.impl";

@Injectable({ providedIn: 'root' })
export class BackendFavoriteDoorService extends FavoriteDoorService {

  favoriteCount$ = new ReplaySubject<number>(1);

  constructor(
    private readonly toggleVisualDoorFavoriteGQL: ToggleVisualDoorFavoriteGQL,
    private readonly countFavoritesGQL: CountFavoritesGQL,
    private customerService: CustomerService
  ) {
    super();
  }

  async toggleFavorite(doorId: string, customerKey: string): Promise<boolean> {
    const result = await lastValueFrom(this.toggleVisualDoorFavoriteGQL.mutate({
      visualDoorId: doorId,
    }));

    this.loadFavoriteDoorCount();

    return !!result?.data?.toggleVisualDoorFavorite;
  }

  loadFavoriteDoorCount(): void {
    this.countFavoritesGQL.fetch({
      customerKey: CustomerServiceImpl.GetCustomerKey()
    }, {
      fetchPolicy: 'no-cache'
    }).pipe(take(1)).subscribe(result => {
      this.favoriteCount$.next(result.data.getFavoriteCount);
    });
  }

  getFavoriteDoorCount(customerKey: string): Observable<number> {
    return this.favoriteCount$;
  }
}
